<template>
<el-container>
 <el-main> 
    <el-form :inline="true" :model="formWorksheetList" class="demo-form-inline">
       <el-form-item label="工单标题">
          <el-input v-model="formWorksheetList.title" placeholder="请输入工单标头"></el-input>
        </el-form-item>
        <el-form-item label="工单">
          <el-select v-model="formWorksheetList.type" placeholder="工单类型" style="width:150px">
            <el-option label="全部" value=""></el-option>
            <el-option label="报装" value="0"></el-option>
            <el-option label="维修" value="1"></el-option>
            <el-option label="咨询" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
    </el-form>
    <template>
    <!-- <el-button @click="resetDateFilter">提交工单</el-button>   -->
    <el-table :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#606266'}" style="margin-top:5px" empty-text="No Data" border>
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
        <el-table-column prop="worksheetNo" label="报装" align="center"></el-table-column>
        <el-table-column prop="type" label="工单类型" align="center"></el-table-column>
        <el-table-column prop="title" label="工单标题" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
        <el-table-column prop="" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </el-main>
  <el-footer>
    <div>
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
    </div>
  </el-footer>    
</el-container>  
</template>
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "worksheetList", //这个LoginName最好和引入的vue的LoginName相同
   data() {
    return {
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      tableData: [],
      formWorksheetList: {
        title: "",
        type: ""
      }
    };
  },
  components: {
    Pagings
  },
   created() {
    this.power();
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },
    power() {
      var formData = new FormData();
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      this.$server
        .exam("/customer/worksheet/listWorksheet", formData)
        .then(data => {
          if (data.code == 200) {
            this.tableData = data.data.records;
            this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    handleSizeChange(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChange(val) {
      this.pageData.offset = val;
      this.power();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/worksheet/worksheetList.vue